export enum EProgressBarStep {
  CREATE_STORE = 'CREATE_STORE',
  INTEGRATIONS = 'INTEGRATIONS',
  GENERAL_CONFIG = 'GENERAL_CONFIG',
  FINISH_STEP = 'FINISH_STEP',
}
